import "./login.css";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <img src={"/img/logo.png"} alt="logo" />
      
      <h1>Welcome To Orca Portal</h1>


      <Button
        width="60%"
        color="rgb(233,193,77)"
        onClick={() => navigate("/")}
        backgroundColor="rgb(21,95,93)"
        margin="50px"
      >
        Continue To Dashboard
      </Button>
    </div>
  );
};
